// libs
import { styled } from '@nykaa/ui-components';	
import { fadeIn } from 'shared/styles/animations/fadeIn';	
import RippleIt from 'shared/components/RippleIt';	

export const APluContainer = styled.section`	
  ${fadeIn}	
  border-bottom: solid 1px ${({ theme }) => theme.colors.textOutline};	
  margin-top: ${({ theme }) => theme.spacing.spacing40};	
`;	

export const Placeholder = styled.div`	
  width: 100%;	
  height: 172px;	
  background: ${({ theme }) => theme.colors.surface20};	
`;	

export const ViewMoreInfoCTA = styled.div`	
  width: 100%;	
  display: flex;	
  justify-content: center;	
  margin-top: ${({ theme }) => theme.spacing.spacing50};	
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};	
`;	

export const ViewMoreInfoText = styled.div`	
  ${({ theme }) => theme.typography.buttonMedium}	
  color: ${({ theme }) => theme.colors.secondary};	
  display: flex;	
  align-items: center;	
`;	

export const ViewMoreIconContainer = styled.div`	
  width: 20px;	
  height: 20px;	
  display: flex;	
  justify-content: center;	
  align-items: center;	
  margin-left: ${({ theme }) => theme.spacing.spacing20};	
  svg path {	
    fill: ${({ theme }) => theme.colors.secondary};	
  }	
`;	

export const RippleItWrapper = styled(RippleIt)`	
  height: 200px;	
`;